import React, {useEffect, useState} from "react";
import {AListItemTitle, ATextInput} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {DropdownMenu} from "components/DropdownMenu";
import MultiSelectCheckbox from "components/MultiSelectCheckbox";
import {
  selectAllEventSources,
  selectEventsLoading,
  selectTotalEventsCount
} from "store/selectors/incidentDetectionSelectors";
import css from "./EventsTableToolbar.module.scss";

const SourceSelect = ({selectedSources, setSelectedSources}) => {
  const sources = useSelector(selectAllEventSources);
  const isLoading = useSelector(selectEventsLoading);
  const totalEventsCount = useSelector(selectTotalEventsCount);

  const [inputVal, setInputVal] = useState("");
  const [sourceOptions, setSourceOptions] = useState([]);

  useEffect(() => {
    setSourceOptions([
      ...sources
        .map((option) => ({title: option, value: option}))
        .filter(
          (option) =>
            !inputVal ||
            !inputVal.length ||
            option.title?.toLowerCase().includes(inputVal.toLowerCase())
        )
    ]);
  }, [sources, inputVal]);

  const selectAllSources = () => {
    selectedSources.length !== sourceOptions.length
      ? setSelectedSources(sourceOptions.map((s) => s.value))
      : setSelectedSources([]);
  };

  return (
    <>
      <DropdownMenu
        buttonClass={classNames(css.select, css.selectSource, "mr-2")}
        buttonContent={
          !selectedSources.length
            ? t("detection.toolbar.source")
            : selectedSources.join(", ")
        }
        buttonVariant="select"
        menuPlacement="bottom-left"
        buttonProps={{
          disabled: isLoading || !totalEventsCount,
          medium: true
        }}>
        <>
          {sources?.length > 5 && (
            <ATextInput
              medium
              className="pa-2"
              placeholder={t("detection.toolbar.source")}
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              clearable
            />
          )}
          <div className="pa-2">
            <a onClick={selectAllSources}>{t("detection.toolbar.selectAll")}</a>
          </div>
          {sourceOptions.map((source, idx) => (
            <MultiSelectCheckbox
              key={idx}
              checkboxAsMenuItem
              value={source.value}
              selected={selectedSources}
              setSelected={(a) => setSelectedSources(a)}>
              <AListItemTitle>{source.title}</AListItemTitle>
            </MultiSelectCheckbox>
          ))}
        </>
      </DropdownMenu>
    </>
  );
};

export default SourceSelect;
